import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createChangeStorymapPrioFrameworkCommand } from '../../api/commands/factory/createPrioCommands';
import { StorymapPrioFrameworkType } from '../../api/queries';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { ClearPrioFilter } from './clearPrioFilter';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SetStorymapFrameworkType extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetStorymapFrameworkType';

    public constructor(public type: StorymapPrioFrameworkType) {
        super(SetStorymapFrameworkType.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetStorymapFrameworkType): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createChangeStorymapPrioFrameworkCommand(action),
    });

    return true;
};

const clearFilterMiddleware = async (): Promise<boolean> => {
    dispatch(new ClearPrioFilter());

    return true;
};

const reducer = (state: StorymapState, action: SetStorymapFrameworkType): void => {
    state.prioFrameworkType = action.type;
};

//@ts-ignore
registerMiddleware(SetStorymapFrameworkType.ACTION_TYPE, middleware);

//@ts-ignore
registerMiddleware(SetStorymapFrameworkType.ACTION_TYPE, clearFilterMiddleware);

//@ts-ignore
registerReducer(SetStorymapFrameworkType.ACTION_TYPE, reducer);
